import { render, staticRenderFns } from "./TaskCommentSection.vue?vue&type=template&id=5b3b50da&"
import script from "./TaskCommentSection.vue?vue&type=script&lang=js&"
export * from "./TaskCommentSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports